export const getBestInDentalStorageKey = (id: string) => `isBestInDentalPopUpShown-${id}`;
